import { Config } from "../../../configurations/config";
export const CompensationLog_API = {
  GetCompensationLogPagination: `${Config.server_url}${Config.api_prefix}/OffsiteHours/CompensationLog?`,
  GetDefaultEmployeeOffsiteRequestByID: `${Config.server_url}${Config.api_prefix}/OffsiteHours/EmployeeOffsiteHourRequests`,
  ExportToExcel: `${Config.server_url}${Config.api_prefix}/OffsiteHours/CompensationLog/ExportToExcel`,
};
